// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__fAzUW","tooltipMobile":"Badge_tooltipMobile__KD0Aw"};